import levels from '../data/levels';
import _ from 'lodash';
export default {
    getLevel(score) {
        return _.find(
            levels,
            level => score >= level.lowest_score && score <= level.highest_score
        );
    },
};
